// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper":"checkbox-wrapper---EcD_4","checkbox-with-asterisk":"checkbox-with-asterisk---yh9t6"};